import {connect} from "react-redux";

import {checkmark, close, warning} from "../icons";
import Alert from "./Alert";
import {hideNotification} from "../../../store/slices/admin/notification";

type Props = {
    type: string,
    msg: string,
    // injected
    dispatch: Function
}

const Notification = (props: Props) => {
    let icon;

    switch (props.type) {
        case "success":
            icon = checkmark;
            break;
        case "error":
        case "warning":
            icon = warning;
            break;
        default:
            icon = false;
    }

    return (
        <Alert type={props.type} isOpen={props.msg.length > 0}>
            {
                icon && <span className="notification-icon">{icon}</span>
            }
            <span className="notification-msg">{props.msg}</span>
            <span className="close-icon d-block" onClick={() => props.dispatch(hideNotification())}>{close}</span>
        </Alert>
    );
};

const  mapStateToProps = (state: any) => {
    return {
        msg: state.notification.msg,
        type: state.notification.type,
    };
};

export default connect(mapStateToProps)(Notification);
